import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/footer/fb.png'
import _imports_1 from '@/assets/image/footer/tw.png'
import _imports_2 from '@/assets/image/footer/ins.png'
import _imports_3 from '@/assets/image/footer/kakao_footer.png'
import _imports_4 from '@/assets/image/icon/line_logo@2x.png'
import _imports_5 from '@/assets/image/footer/TikTok.svg'
import _imports_6 from '@/assets/image/footer/youtobe.svg'
import _imports_7 from '@/assets/image/footer/home-d2c.png'


const _withScopeId = n => (_pushScopeId("data-v-791a6146"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Footer" }
const _hoisted_2 = { class: "column-th" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "column-td" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "viewport flex-bwn flex-ter" }
const _hoisted_7 = { class: "flex-ter content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: "https://static-s.theckb.com/BusinessMarket/Client/logo_ja_footer.png",
  alt: ""
}, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "line"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = ["to"]
const _hoisted_12 = { class: "Footer-bottom" }
const _hoisted_13 = { class: "left" }
const _hoisted_14 = { class: "left-logo" }
const _hoisted_15 = {
  key: 0,
  referrerPolicy: "no-referrer",
  src: "https://static-jp.theckb.com/static-asset/client/homelogo.png"
}
const _hoisted_16 = {
  key: 1,
  referrerPolicy: "no-referrer",
  src: "https://static-s.theckb.com/BusinessMarket/Client/homelogo.png"
}
const _hoisted_17 = { class: "left-social" }
const _hoisted_18 = ["href"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_0
}, null, -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_1
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_2
}, null, -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 0,
  href: "https://pf.kakao.com/_uzWxoxj",
  target: "_blank"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_3
}, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["href"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_4
}, null, -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["href"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_5
}, null, -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = ["href"]
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_6
}, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = { class: "right" }
const _hoisted_40 = ["href"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  referrerPolicy: "no-referrer",
  src: _imports_7
}, null, -1))
const _hoisted_42 = ["href"]

import { list, krList, enList } from '@/assets/js/footer/data'
import { useRtfix, useSite, useSite2Station, isJA, isKO, isD2C } from '@/store'
import { t } from '@/plugins/i18n'
import { Site, lineUrl } from '@/common/const'
import { ref, onMounted, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import KoFooter from './components/KoFooter.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const station = useSite2Station()
const hasConcat = ref(false)
watch(() => route.path, (val) => {
  hasConcat.value = isJA() && val.endsWith('/hub/ec')
}, { immediate: true })

const cdnAssets = (str: string) =>
  `https://static-s.theckb.com/BusinessMarket/SEO/${str.replace(
    /(^[^.]+$)/,
    '$1.png'
  )}`
const jaConcat = [
  { name: '1688', logo: '', texts: ['運营元：SNIFF GROUP', '住所：浙江省杭州アリババセンタ-7階'], website: 'www.sniffgroup.com' },
  { name: 'itochu', logo: cdnAssets('partner/itochu'), texts: ['CKB(直行便) × 正規代理店：伊藤忠商事', '〒107-8077 東京都港区北青山2丁目5番1号'], website: 'www.itochu.co.jp' },
  { name: 'itsumo', logo: cdnAssets('partner/itsumo'), texts: ['THE直行便正式代理店：株式会社 itsumo', '〒100-0006東京都千代田区有楽町一丁目13番2号第一生命日比谷 21階'], website: 'www.itsumo365.co.jp' }
]

/**
 * 根据站点，处理url
 * @param link ep: https://www.theckb.com/price/plan/
 * @return ko https://www.theckb.com/ko/price-ko/plan-ko/
 */
const replaceLinkBaseOnSite = (link: string) => {
  const site = useSite()
  // 若url中含有，则不做处理
  const reg = /(b2b)|(d2c)/g
  if (reg.test(link)) return link

  const baseUrl = 'https://www.theckb.com'
  const map = {
    [Site.JA]: '/',
    [Site.KO]: '/ko/',
    [Site.EN]: '/en/'
  }[station]

  // 正则匹配到的路径 ["price", "plan"]
  const paths: string[] = []

  // 去掉baseUrl的子串 '/price/plan/'
  const route = link.split(baseUrl)[1]
  // 正则匹配
  route.replace(/(?<=\/).*?(?=\/)/gi, match => {
    paths.push(match)
    return match
  })

  // 给路由path添加对应的站点前缀 ["price", "plan"]
  const pathCatLangType = paths.map(path => {
    return `${site}-${path}`
  }).join('/').concat('/')
  const result = baseUrl + map + pathCatLangType

  return result
}

const vForList = ref(list)

onMounted(() => {
  const station = useSite2Station()

  vForList.value = {
    [Site.JA]: list,
    [Site.KO]: krList,
    [Site.EN]: enList
  }[station]
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(isKO)())
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["Footer-main viewport", { 'flex-rev': _unref(isKO)() }]),
          style: _normalizeStyle(_unref(station) === _unref(Site).KO ? 'height: 112px' : '')
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vForList.value, (column) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "column",
              key: column.id
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("a", {
                  class: "hover",
                  href: column.url,
                  target: "_blank"
                }, _toDisplayString(_unref(t)(column.title)), 9, _hoisted_3)
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column.linkList, (row, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "column-td-row",
                    key: index
                  }, [
                    _createElementVNode("a", {
                      class: "hover",
                      href: row.url,
                      target: "_blank"
                    }, _toDisplayString(_unref(t)(row.label)), 9, _hoisted_5)
                  ]))
                }), 128))
              ])
            ]))
          }), 128))
        ], 6))
      : _createCommentVNode("", true),
    (hasConcat.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["concat", _unref(isD2C)() ? 'concat-d2c' : 'concat-b2b'])
        }, [
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(jaConcat, (v, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "jaConcat"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  (v.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                    : _createCommentVNode("", true),
                  (v.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "logo",
                        src: v.logo,
                        alt: ""
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(v.texts, (text, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "text-[12px]"
                  }, _toDisplayString(text), 1))
                }), 128)),
                _createElementVNode("a", {
                  to: `https://${v.website}`
                }, _toDisplayString(v.website), 9, _hoisted_11)
              ])
            }), 64))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_unref(isKO)())
      ? (_openBlock(), _createBlock(KoFooter, { key: 2 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("img", _hoisted_15))
            : (_openBlock(), _createElementBlock("img", _hoisted_16))
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            href: _unref(isJA)() ? 'https://www.facebook.com/profile.php?id=100088353218048' : _unref(isKO)() ? 'https://www.facebook.com/profile.php?id=100086914794478' : 'https://www.facebook.com/profile.php?id=100090941351148',
            target: "_blank"
          }, _hoisted_20, 8, _hoisted_18),
          _createElementVNode("a", {
            href: _unref(isJA)() ? 'https://twitter.com/Theckb_official' : _unref(isKO)() ? 'https://twitter.com/k_theckb' : 'https://twitter.com/TheCKB_us',
            target: "_blank"
          }, _hoisted_23, 8, _hoisted_21),
          _createElementVNode("a", {
            href: _unref(isJA)() ? 'https://www.instagram.com/theckb_official/' : _unref(isKO)() ? 'https://www.instagram.com/korea_theckb/' : 'https://www.instagram.com/theckb_en/?img_index=5',
            target: "_blank"
          }, _hoisted_26, 8, _hoisted_24),
          (_unref(isKO)())
            ? (_openBlock(), _createElementBlock("a", _hoisted_27, _hoisted_29))
            : _createCommentVNode("", true),
          (_unref(isJA)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 1,
                href: _unref(lineUrl),
                target: "_blank"
              }, _hoisted_32, 8, _hoisted_30))
            : _createCommentVNode("", true),
          (!_unref(isKO)())
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _unref(isJA)() ? 'https://www.tiktok.com/@the_ckb' : _unref(isKO)() ? 'https://www.tiktok.com/@theckb_en?lang=en' : 'https://www.tiktok.com/@theckb_en?lang=en',
                target: "_blank"
              }, _hoisted_35, 8, _hoisted_33))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            href: _unref(isJA)() ? 'https://www.youtube.com/@theckb2011' : _unref(isKO)() ? 'https://youtube.com/@theckb_korea?si=Tx1acBa4UsUrFDtA' : 'https://www.youtube.com/@theckb_en/videos',
            target: "_blank"
          }, _hoisted_38, 8, _hoisted_36)
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        (!_unref(isKO)())
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: _unref(isJA)() ? 'https://www.theckb.com/' : 'https://www.theckbkorea.com/',
              target: "_blank"
            }, [
              _hoisted_41,
              _createTextVNode(" " + _toDisplayString(_unref(t)('主站')), 1)
            ], 8, _hoisted_40))
          : _createCommentVNode("", true),
        (!_unref(isKO)())
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              href: _unref(isJA)() ? 'https://www.theckb.com/company/' : _unref(isKO)() ? 'https://www.theckbkorea.com/%ED%9A%8C%EC%82%AC-%EC%A0%95%EB%B3%B4' : 'https://www.theckbofficial.com/about-9',
              target: "_blank"
            }, _toDisplayString(_unref(t)('会社情報')), 9, _hoisted_42))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('agreement')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('使用条约')), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          to: _unref(useRtfix)('policy')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('隐私权政策')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ])
    ])
  ]))
}
}

})